export default __webpack_public_path__ + "static/SEAT Ibiza-6cf64c959655f2ec6cf152eae87fa955.png";